import "@fontsource/fredoka";
import { createTheme } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface Palette {
    darkBlue: string;
  }
  interface PaletteOptions {
    darkBlue: string;
  }
}

const DARK_BLUE_COLOR = "#07154E";
const SUCCESS_COLOR = "#56C65B";
const SECONDARY = "#FFBA34";

const { palette } = createTheme();

const theme = createTheme({
  palette: {
    primary: {
      dark: "#3A0CA3",
      main: "#015FEE",
      contrastText: "#fff",
      light: "#DDEAFD",
    },
    secondary: {
      main: SECONDARY,
      contrastText: "#fff",
    },
    success: {
      main: SUCCESS_COLOR,
      contrastText: "#fff",
    },
    darkBlue: palette.augmentColor({
      color: {
        main: DARK_BLUE_COLOR,
      },
      name: "darkBlue",
    }),
  },
  typography: {
    fontFamily: ["Fredoka", "sans-serif"].join(","),
    fontSize: 16,
  },
  components: {
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          // svg: {
          //   color: "black",
          // },
        },
        positionStart: {
          marginRight: 8,
        },
        positionEnd: {
          marginRight: -8,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "12px",
          backgroundColor: "white",
          padding: "12px",
          paddingLeft: "24px",
          paddingRight: "24px",
          height: "60px",
        },
        input: {
          paddingLeft: 0,
          paddingRight: 0,
        },
        notchedOutline: {
          border: "none",
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          height: 60,
          borderRadius: 12,

          "&.Mui-disabled": {
            color: "white",
            backgroundColor: "rgba(255, 255, 255, 0.25)",
          },
        },
        contained: {
          color: "white",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h1: {
          fontFamily: "Fredoka",
          fontSize: "2.5rem",
          fontWeight: 400,
          color: DARK_BLUE_COLOR,
        },
        h3: {
          fontFamily: "Fredoka",
          fontSize: "1.5rem",
          fontWeight: 400,
          color: DARK_BLUE_COLOR,
        },
        h4: {
          fontFamily: "Fredoka",
          fontSize: "1.25rem",
          fontWeight: 400,
          color: DARK_BLUE_COLOR,
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(255, 255, 255, 0.1)",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          height: 60,
          borderRadius: 30,
          paddingLeft: 16,
          paddingRight: 16,
        },
        outlined: {
          borderWidth: 2,
          color: "white",
        },
        outlinedSecondary: {
          borderColor: "rgba(255, 255, 255, 0.25)",
        },
        filledSecondary: {
          "& .MuiChip-icon": {
            color: "white",
          },
        },
        label: {
          width: "100%",
          textAlign: "center",
          textTransform: "uppercase",
          fontFamily: "Fredoka",
          fontWeight: 600,
        },
        iconColorSecondary: {
          color: SECONDARY,
        },
      },
    },
  },
});

export default theme;
